import {
  useMemo,
  useState,
  Dispatch,
  ReactNode,
  createContext,
  SetStateAction,
} from "react";

import dayjs, { Dayjs } from "dayjs";

import {
  dayjsToAPI,
  defaultAfterDate,
  defaultBeforeDate,
} from "utils/data/date";

interface Context {
  afterDate?: Dayjs | number | string;
  afterDateStr?: string;
  setAfterDate?: Dispatch<SetStateAction<Dayjs | number | string>>;
  beforeDate?: Dayjs | number | string;
  beforeDateStr?: string;
  setBeforeDate?: Dispatch<SetStateAction<Dayjs | number | string>>;
  isAllSelected?: boolean;
  setIsAllSelected?: Dispatch<SetStateAction<boolean>>;
}

export const TimeRangeContext = createContext<Context>({});

interface TimeRangeProviderProps {
  children: ReactNode;
}

export const TimeRangeProvider = ({ children }: TimeRangeProviderProps) => {
  const [afterDate, setAfterDate] = useState<Dayjs | number | string>(
    defaultAfterDate
  );
  const [beforeDate, setBeforeDate] = useState<Dayjs | number | string>(
    defaultBeforeDate
  );
  const [isAllSelected, setIsAllSelected] = useState<boolean>(true);

  const afterDateStr = useMemo(() => afterDate as string, [afterDate]);
  const beforeDateStr = useMemo(() => beforeDate as string, [beforeDate]);

  const afterDateValue = useMemo(() => {
    // if (isAllSelected) return dayjs.utc(0);
    return afterDate;
  }, [afterDate, isAllSelected]);

  const beforeDateValue = useMemo(() => {
    return beforeDate;
  }, [beforeDate, isAllSelected]);

  const context: Context = useMemo(
    () => ({
      afterDate: afterDateValue,
      beforeDate: beforeDateValue,
      afterDateStr,
      beforeDateStr,
      setAfterDate,
      setBeforeDate,
      isAllSelected,
      setIsAllSelected,
    }),
    [
      afterDateStr,
      afterDateValue,
      beforeDateStr,
      beforeDateValue,
      isAllSelected,
    ]
  );

  return (
    <TimeRangeContext.Provider value={context}>
      {children}
    </TimeRangeContext.Provider>
  );
};
